<template>
    <vx-expandable-card>
        <template v-slot:header>Organizational Unit</template>
        <template v-slot:content>
            <select-org-unit v-model="model" :disabled="!onCorporate()" size="lg"></select-org-unit>
            <vx-alert v-if="!onCorporate()" class="mt-4" :closeable="false" color="slate">
                Only corporate can edit the Organizational Unit of a Group.
            </vx-alert>
        </template>
    </vx-expandable-card>
</template>

<script setup>
import { VxAlert, VxExpandableCard } from '@voxie/frontend-components';
import SelectOrgUnit from '~/components/general/SelectOrgUnit.vue';
import { useCurrentGroup } from '~/composables/useCurrentGroup';

const { onCorporate } = useCurrentGroup();
const model = defineModel();
</script>
